import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePurchaseSuggestion from "./component/tables/TablePurchaseSuggestion";

function PurchaseSuggestionRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePurchaseSuggestion />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchaseSuggestionRegister;